import { Button, Stack } from '@mui/material';
import { DaySchedule } from './DaySchedule';
import React, { useState, useMemo, useEffect } from 'react';
import { scheduleDefaults } from '~/shared/const/scheduleDefaults';
import { ITimeData } from '~/shared/types/types';
import { convertSchedule } from '~/shared/utils/convertSchedule';

export const WeeklySchedule: React.FC<ITimeData> = ({
  schedule,
  scheduleData,
  setSchedule,
  handleCloseSchedule,
}) => {
  const [selectedIntervals, setSelectedIntervals] = useState<any>({});

  const sendData = useMemo(() => {
    return convertSchedule(selectedIntervals);
  }, [selectedIntervals]) as any;

  useEffect(() => {
    if (Array.isArray(schedule)) {
      const transformed = schedule.reduce((acc, item) => {
        const formatTime = ({ hour, minute }: any) =>
          `${String(hour).padStart(2, '0')}:${String((minute - 2) * 15).padStart(2, '0')}`;
        acc[item.day] = {
          from: formatTime(item.from),
          to: formatTime(item.to),
        };
        return acc;
      }, {});
      setSelectedIntervals(transformed);
    }
  }, [schedule]);

  const handleIntervalChange = (day: number, interval: any) => {
    setSelectedIntervals((prev: any) => {
      if (!interval.from && !interval.to) {
        const newState = { ...prev } as any;
        delete newState[day];
        return newState;
      }

      return { ...prev, [day]: interval };
    });
  };

  return (
    <div className="schedule-container">
      <div className="weekly-schedule">
        {scheduleData.map(dayData => (
          <DaySchedule
            key={dayData.day}
            day={dayData.day}
            availableFrom={dayData.from}
            availableTo={dayData.to}
            selectedInterval={selectedIntervals[dayData.day]}
            onIntervalChange={handleIntervalChange}
          />
        ))}
      </div>
      <Stack flexDirection="row" gap="24px" marginTop="48px">
        <Stack flex={1}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setSelectedIntervals(scheduleDefaults)}>
            Сбросить
          </Button>
        </Stack>
        <Stack flex={1}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              if (!selectedIntervals) {
                setSelectedIntervals(scheduleDefaults);
              } else {
                setSchedule(sendData);
              }
              handleCloseSchedule();
            }}>
            OK
          </Button>
        </Stack>
      </Stack>
    </div>
  );
};
